export default function loadHeaderMenu(schedulerElements = [], returnAvailableLanguages = false) {
	const headerMenu = new window.WebServicePromise({
		url: '/Services/SchedulerWs.svc/GetMenu'
	});
	let availableLanguages = null;
	const languages = sw2.getAllLanguages().then(resp => {
		availableLanguages = JSON.parse(JSON.stringify(resp));
		return resp;
	});
	return $.when(headerMenu, languages).then(([menu], languages) => {

		menu.mainMenu.splice(0, 0, {
			menu: "languages",
			items: languages
		});

		var mappedMenu = schedulerElements.slice();

		var menuElements = menu.mainMenu.map(elem => {
			var menuItems = elem.items || [];
			if (elem.menu === 'Reservations') {
				let newMenuItems = menuItems.map(item => {
					return {
						menu: item.menu,
						url: `reservations.aspx?${window.use_classic ? 'useClassic=true&' : ''}formid=${item.id}`
					};
				});
				if (!menu.config.hideGenericReservationEntryPage) {
					newMenuItems.push({
						menu: sw2.intl['common.header.schedule'].format(),
						url: 'scheduler.aspx'
					});
				}
				const facilitiesGroupId = 4;
				if (sw2.loginService.isAdmin() || sw2.loginService.groupids.indexOf(facilitiesGroupId) > -1) {
					newMenuItems.push({
						menu: sw2.intl['common.header.categories-and-colours'].format(),
						select: function () {
							var o = new window.kendoDialog();
							o.id = 'categories';
							o.width = '700px';
							o.height = '410px';
							o.initialFunctionName = 'ctInit';
							o.url = window.appendQueryString('popup-categories.aspx', location.href);
							o.afterSave = function () {
								sw2.settingsService.load();
							};
							o.displayCentered();
						}
					});
				}
				return {
					menu: sw2.intl['common.header.reservations'].format(),
					items: newMenuItems
				};
			} else if (elem.menu === 'Dashboards') {
				let newMenuItems = menuItems.map(item => {
					return {
						menu: item.menu,
						url: "report.aspx?id=" + encodeURIComponent(item.id),
					};
				});
				return {
					menu: sw2.intl['common.header.dashboards'].format(),
					items: newMenuItems
				};
			} else if (elem.menu === 'Reporting') {
				let newMenuItems = menuItems.map(item => {
					return {
						menu: item.menu,
						url: item.menu !== "Add a report" ? "report.aspx?id=" + item.id : "",
						select: item.menu === "Add a report" ? function () {
							if (window.location.href.indexOf('manage-reports.aspx') > -1) {
								window.newRecord();
							} else {
								sw2.navigate("manage-reports.aspx");
							}
						} : null
					};
				});
				return {
					menu: sw2.intl['common.header.reporting'].format(),
					items: newMenuItems
				};
			} else if (elem.menu === 'Integrations') {
				if (!sw2.loginService.isAdmin() && menu.config.userHasIntegration) {
					return {
						menu: sw2.intl['common.header.integrations'].format(),
						url: 'manage-integrations.aspx'
					};
				} else {
					return;
				}
			} else if (elem.menu === 'Admin') {
				var options = [{
					menu: sw2.intl['common.header.notifications'].format(),
					url: 'manage-notifications.aspx'
				}, {
					menu: sw2.intl['common.header.locations'].format(),
					url: 'manage-locations.aspx'
				}, {
					menu: sw2.intl['common.header.floorplans'].format(),
					url: 'manage-locations2.aspx'
				}, {
					menu: sw2.intl['common.header.users'].format(),
					url: 'manage-users.aspx'
				}, {
					menu: sw2.intl['common.header.services'].format(),
					url: 'manage-services.aspx'
				}, {
					menu: sw2.intl['common.header.reports'].format(),
					url: 'manage-reports.aspx'
				}, {
					menu: sw2.intl['common.header.rules'].format(),
					url: 'manage-rules.aspx'
				}, {
					menu: sw2.intl['common.header.fields'].format(),
					url: 'manage-fields.aspx'
				}, {
					menu: sw2.intl['common.header.devices'].format(),
					url: 'manage-devices.aspx'
				}, {
					menu: sw2.intl['common.header.layers'].format(),
					url: 'manage-layers.aspx'
				}, {
					menu: sw2.intl['common.header.forms'].format(),
					url: 'manage-forms.aspx'
				}, {
					menu: sw2.intl['common.header.translations'].format(),
					url: 'manage-translations.aspx'
				}];
				if (sw2.loginService.isAdmin()) {
					options.push({
						menu: sw2.intl['common.header.integrations'].format(),
						url: 'manage-integrations.aspx'
					});
				}
				if (menu.config.userHasSettings) {
					options.push({
						menu: sw2.intl['common.header.admin-settings'].format(),
						url: 'manage-settings.aspx'
					});
				}
				options.sort((a, b) => a.menu.localeCompare(b.menu, 'en'));
				return {
					menu: sw2.intl['common.header.admin'].format(),
					items: options
				};
			} else if (elem.menu === 'languages') {
				const filteredLangs = elem.items.filter(item => item.enabled);
				return {
					spriteCssClass: 'k-icon k-i-globe-outline fix-k-sprite',
					menu: filteredLangs.filter(lang => lang.id === sw2.loginService.locale)[0]?.name ?? filteredLangs[0].name,
					items: filteredLangs.map(lang => {
						return {
							menu: lang.name,
							attr: {
								lang: lang.id
							},
							select() {
								webServiceRequest.prototype.displayWaitDialog();
								new window.WebServicePromise({
									url: '/webapi/languages/setuserlanguage',
									headers: {
										auth_token: sw2.loginService?.logintoken
									},
									data: {
										language: lang.id,
										token: null
									}
								}).then(logintoken => {
									if (logintoken) {
										const form = $('#token').closest('form');
										const inp = $('<input type="hidden" name="token" />');
										inp.val(logintoken);
										form.append(inp);
										form.submit();
									}
								})
									.always(() => webServiceRequest.prototype.hideWaitDialog());
							}
						};
					})
				};
			}
			return elem;
		});

		menuElements[menuElements.length - 1].items = [{
			menu: sw2.intl['common.header.user-settings'].format(),
			url: 'user-settings.aspx'
		}, {
			menu: sw2.intl['common.header.logout'].format(),
			select: function () {
				sw2.loginService.logout();
			}
		},
		{
			menu: "HubStar Connect (v" + sw2._appVersion + " - " + sw2.loginService.get('internaldbtoken') + ")"
		}
		];

		menuElements.forEach(el => {
			if (el) {
				var element = document.createElement("div");
				element.innerText = el.menu;
				mappedMenu.push({
					text: el.url ? "<a onclick='sw2.navigateClickHandler(href); return false;' class='anchor-menu anchor-menu-main' href=" + el.url + " role='menuitem' class='k-link k-menu-link'>" + element.innerHTML + "</a>" : element.innerHTML,
					select: function () {
						sw2.navigate(el.url);
					},
					cssClass: el.url ? "links-options" : '',
					spriteCssClass: el?.spriteCssClass,
					attr: el?.attr,
					encoded: false,
					items: el.items ? el.items.map(item => {
						element.innerText = item.menu;
						return {
							text: item.url ? "<a onclick='sw2.navigateClickHandler(href); return false;' class='anchor-menu anchor-menu-options ' href=" + item.url + " role='menuitem' class='k-link k-menu-link'>" + element.innerHTML + "</a>" : element.innerHTML,
							encoded: false,
							select: item.select || null,
							cssClass: item.url ? "links-options" : '',
							spriteCssClass: item?.spriteCssClass,
							attr: item?.attr
						};
					}) : null
				});
			}
		});
		const THEME_KEY = 'webth';
		let device_experience_choice = localStorage.getItem(THEME_KEY);
		const smart_experience_toggle = sw2.loginService?.featureflags?.['FF-smart-experience-toggle'];
		const smart_experience_force_session = smart_experience_toggle === 'forcechangesession';
		const smart_experience_preserve_session = smart_experience_toggle === 'preservesession';
		if (sw2.loginService?.featureflags?.['FF-smart-experience'] === 'enabled'
			&& (smart_experience_force_session || smart_experience_preserve_session)
			&& window.getIsOptionalChainingSupported()
			&& window.Proxy
			&& (device_experience_choice || !window.use_classic || smart_experience_force_session)
			&& (location.href.indexOf('scheduler.aspx') > -1 || location.href.indexOf('reservations.aspx') > -1)) {
			const CLASSIC = 'dfff3ebb-5bec-4442-9790-d2cfb4f1d82d';
			//insert button before last column
			mappedMenu.splice(-1, 0, {
				text: `<div class="app-opt-in"><div class="main flex justify-between">
			<img src="client/smartway2/mobile/balloons.svg" />
			<div class="title">${sw2.intl['outlookui.settings.try-new-theme'].format()}</div>
			<label class="switch">
				<input type="checkbox" ${device_experience_choice ? 'checked' : ''}>
				<span class="circle round"></span>
			</label></div></div>`,
				encoded: false,
				cssClass: 'se',
				select(ev) {
					ev.preventDefault();
					if (!window.use_classic && !device_experience_choice) {
						if (sw2.settingsService._orig.recommendedthemeid !== CLASSIC) {
							localStorage.setItem(THEME_KEY, sw2.settingsService._orig.recommendedthemeid);
						} else {
							localStorage.setItem(THEME_KEY, '!' + CLASSIC);
						}
						localStorage.setItem('dbtoken', sw2.serverUrl());
						sw2.profileStorage.setKey(THEME_KEY, localStorage.getItem(THEME_KEY)).always(function () {
							// even if it fails we still want to transition, just means that the setting will not be taken with the user to a different device
							window.location.href = '/se/';
						});
					} else if (device_experience_choice) {
						const menu_option = $(ev.target);
						menu_option.find('input')[0].checked = false;
						if (!smart_experience_force_session) {
							sw2.navigate('scheduler.aspx');
						}
						device_experience_choice = null;
						localStorage.removeItem(THEME_KEY);
						sw2.profileStorage.setKey(THEME_KEY, undefined);
					} else if (smart_experience_force_session) {
						const COOKIE_DURATION_SHORT = 1;
						if (sw2.settingsService._orig.recommendedthemeid !== CLASSIC) {
							localStorage.setItem(THEME_KEY, sw2.settingsService._orig.recommendedthemeid);
						} else {
							localStorage.setItem(THEME_KEY, '!' + CLASSIC);
						}
						sw2.profileStorage.setKey(THEME_KEY, device_experience_choice).always(function () {
							//get current token from cookie if one exists
							new window.WebServicePromise({
								url: '/Services/UsersWS.svc/ValidateLoginToken',
								data: {
									cooieduration: COOKIE_DURATION_SHORT,
									token: '',
								},
							}).always(function (resp) {
								if (resp.logintoken === sw2.loginService.logintoken) {
									window.location.href = '/se/';
								} else {
									//terminate cookie token
									new window.WebServicePromise({
										url: '/Services/UsersWS.svc/Logout2',
										data: {
											token: resp.logintoken,
										},
									}).always(function () {
										// even if it fails we still want to transition, just means that the setting will not be taken with the user to a different device
										const post_body = {
											token: sw2.loginService.logintoken,
											timezone: sw2.loginService.timezone,
											cookieduration: COOKIE_DURATION_SHORT,
										};
										//set new cookie
										new window.WebServicePromise({
											url: '/Services/UsersWS.svc/ValidateLoginToken',
											data: post_body,
										}).then(function () {
											window.location.href = '/se/';
										});
									});
								}

							});
						});
					}
					return;
				}
			});
			const previous_choice = sw2.profileStorage.getValue(THEME_KEY);
			if (previous_choice && previous_choice !== CLASSIC && device_experience_choice !== previous_choice && !window.use_classic) {
				localStorage.setItem(THEME_KEY, previous_choice);
				window.location.href = '/se/';
				return;
			}
		}
		if (returnAvailableLanguages) {
			return {
				mappedMenu,
				availableLanguages
			};
		} else {
			return mappedMenu;
		}
	}).fail((err) => {
		console.log(err);
	});
}
